import { graphql, StaticQuery } from "gatsby"
import React, { Component } from "react"

import ExperienceTile from "./widgets/ExperienceTile"

import * as experienceStyles from "../styles/experience.module.css"

class Experience extends Component {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query ExperienceQuery {
            dataJson(title: { eq: "Experience" }) {
              jobs {
                name
                company
                year
                desc
                img {
                  childImageSharp {
                    fluid {
                      ...GatsbyImageSharpFluid
                    }
                  }
                }
              }
            }
          }
        `}
        render={data => (
          <React.Fragment>
            <div
              className="container"
              data-sal="fade"
              data-sal-delay="50"
              data-sal-easing="ease"
            >
              <div className={experienceStyles.divider}></div>
              <div className={experienceStyles.title}>
                {/* {data.markdownRemark.frontmatter.title} */}
                EXPERIENCE
                <div className={experienceStyles.desc}>
                  &lt;INTERNSHIPS & WORK/&gt;
                </div>
              </div>
              <div className={`row ${experienceStyles.row}`}>
                {data.dataJson.jobs.map(job => (
                  <ExperienceTile
                    key={job.name + job.year}
                    name={job.name}
                    company={job.company}
                    desc={job.desc}
                    year={job.year}
                    fluid={job.img.childImageSharp.fluid}
                  />
                ))}
              </div>
            </div>
          </React.Fragment>
        )}
      />
    )
  }
}
export default Experience
